import { UIComponentViewImpl } from '../uicomponentview';
import * as React from 'react';
import { GridTabCSSStyle } from './gridtabcss';
import { GridTabComponentProps, GridTabComponentState, GridTabComponentHandler } from './gridtabcomponent';
import { ToggleButtonCSSStyleImpl } from '../togglebutton/togglebuttoncss';
import { ToggleButtonGroupComponent } from '../togglebuttongroup/togglebuttongroupcomponent';

export class GridTabViewImpl<T> extends UIComponentViewImpl<T>
{
    bindHandlers()
    {
        this.onTabSelected = this.onTabSelected.bind(this);
    }

    draw(props: GridTabComponentProps, state: GridTabComponentState, cssStyle: GridTabCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return(
            <div style={cssStyle.getWrapperCSSStyle()}>
             
             {props.isShowTabsTitle && <ToggleButtonGroupComponent onTabSelected={this.onTabSelected} initialSelection={state.selectedTabTitle} style={new ToggleButtonCSSStyleImpl(props.context)} context={props.context} listOfTitles={props.genericTabViewModel.getListOfTitles()} />}
             
             {state.selectedTabContent !== false && <div style={cssStyle.getTabContentCSSStyle()}>
               {
                   state.selectedTabContent
               }
           </div>}
            </div>
       );
    }

    private onTabSelected(title: string): void
    {
        (this.getUIComponentHandler() as GridTabComponentHandler).onTabSelected(title);
    }
}
 {/* <div style={cssStyle.getTabHeaderCSSStyle()}>
                {
                      props.genericTabViewModel.getListOfTitles().map((entry: any, index: number)=>
                      {
                        return <>
                                  <ToggleButtonComponent style={new ToggleButtonCSSStyleImpl(props.context)} isSelected={props.initialTab === entry ? true : false} context={props.context} label={entry} onClick={() =>this.onTabSelected(entry)}/>
                                  {/* <label key={index} onClick={() =>this.onTabSelected(entry)} style={cssStyle.getTabLinkCSSStyle(state.selectedTabTitle === entry)}>{entry}</label> */}
                                  {/* {
                                    (props.genericTabViewModel.getListOfTitles().length - 1) !== index &&
                                    <div style={cssStyle.getPipeCSSStyle()}>
                                      {"|"}
                                  </div>
                                  } */}
                              {/* </>; */}
                      {/* }) */}
                {/* } */} 
{/* <button class="tablink" onclick="openPage('Home', this, 'red')">Home</button>
<button class="tablink" onclick="openPage('News', this, 'green')" id="defaultOpen">News</button>
<button class="tablink" onclick="openPage('Contact', this, 'blue')">Contact</button>
<button class="tablink" onclick="openPage('About', this, 'orange')">About</button>

<div id="Home" class="tabcontent">
  <h3>Home</h3>
  <p>Home is where the heart is..</p>
</div>

<div id="News" class="tabcontent">
  <h3>News</h3>
  <p>Some news this fine day!</p> 
</div>

<div id="Contact" class="tabcontent">
  <h3>Contact</h3>
  <p>Get in touch, or swing by for a cup of coffee.</p>
</div>

<div id="About" class="tabcontent">
  <h3>About</h3>
  <p>Who we are and what we do.</p>
</div> */}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/gridtabs/gridtabview.tsx